<template>
  <div>
    <div class="mt-3" v-if="Boolean(cubedata)">
      <span>Facts</span>
      <treeselect
        v-model="selectedMeasureGroups"
        :multiple="true"
        :options="sortedMeasureGroups"
        :normalizer="NormalizerFacts"
        value-consists-of="LEAF_PRIORITY"
        @select="measureGroupChangedBySelect"
        @deselect="measureGroupChangedBySelect"
      ></treeselect>
    </div>
    <div class="mt-3" v-if="relatedFilters.length > 0">
      <span>Filters</span>
      <treeselect
        v-model="selectedFilters"
        :multiple="true"
        :options="sortedRelatedFilters"
        disable-branch-nodes
        show-count
        value-consists-of="LEAF_PRIORITY"
      ></treeselect>
    </div>
    <div class="mt-3" v-if="relatedMeasures.length > 0">
      <span>Measures</span>
      <treeselect
        v-model="selectedMeasures"
        :multiple="true"
        :options="sortedRelatedMeasures"
        disable-branch-nodes
        show-count
        value-consists-of="LEAF_PRIORITY"
        :default-expand-level="1"
      ></treeselect>
    </div>
    <div class="mt-3" v-if="relatedLevels.length > 0">
      <span>Dimensions</span>
      <treeselect
        v-model="selectedLevels"
        :multiple="true"
        :options="sortedRelatedLevels"
        disable-branch-nodes
        show-count
        value-consists-of="LEAF_PRIORITY"
      ></treeselect>
    </div>
  </div>
</template>

<script>
/*global _*/
import notification from "@/mixins/notification";

export default {
  mixins: [notification],
  props: ["cubedata", "measureGroups", "filters", "measures", "levels"],
  data() {
    return {
      relatedMeasures: [],
      relatedLevels: [],
      relatedFilters: [],
      result: []
    };
  },
  computed: {
    sortedMeasureGroups() {
      return _.sortBy(this.cubedata.measureGroups, ["measureGroupCaption"]);
    },
    sortedRelatedFilters() {
      var sorted = _.sortBy(this.relatedFilters, ["label"]);
      var sortedAll = _.forEach(sorted, function(v) {
        if (v.children) {
          v.children = _.sortBy(v.children, ["label"]);
        }
      });
      return sortedAll;
    },
    sortedRelatedMeasures() {
      var sorted = _.sortBy(this.relatedMeasures, ["label"]);
      var sortedAll = _.forEach(sorted, function(v) {
        if (v.children) {
          v.children = _.sortBy(v.children, ["label"]);
        }
      });
      return sortedAll;
    },
    sortedRelatedLevels() {
      var sorted = _.sortBy(this.relatedLevels, ["label"]);
      var sortedAll = _.forEach(sorted, function(v) {
        if (v.children) {
          v.children = _.sortBy(v.children, ["label"]);
        }
      });
      return sortedAll;
    },
    selectedMeasureGroups: {
      set: function(newVal) {
        var vm = this;
        var measureGroups = [];
        _.forEach(newVal, function(measureGroupId) {
          measureGroups.push(
            _.find(vm.cubedata.measureGroups, {
              measureGroupId: measureGroupId
            })
          );
        });
        this.$emit("update:measureGroups", measureGroups);
      },
      get: function() {
        var vm = this;
        return _.flatMap(vm.measureGroups, function(v) {
          return v.measureGroupId;
        });
      }
    },
    selectedMeasures: {
      set: function(newVal) {
        var vm = this;
        var measures = [];
        _.forEach(newVal, function(measureId) {
          measures.push(_.find(vm.cubedata.measures, { measureId: measureId }));
        });
        this.$emit("update:measures", measures);
      },
      get: function() {
        var vm = this;
        return _.flatMap(vm.measures, function(v) {
          return v.measureId;
        });
      }
    },
    selectedLevels: {
      set: function(newVal) {
        var vm = this;
        var levels = [];
        _.forEach(newVal, function(levelId) {
          levels.push(_.find(vm.cubedata.levels, { levelId: levelId }));
        });
        this.$emit("update:levels", levels);
      },
      get: function() {
        var vm = this;
        return _.flatMap(vm.levels, function(v) {
          return v.levelId;
        });
      }
    },
    selectedFilters: {
      set: function(newVal) {
        var vm = this;
        var oldVal = vm.selectedFilters;
        var levelIds = _.xorWith(newVal, oldVal, _.isEqual);
        if (levelIds.length > 0) {
          var level = _.find(vm.cubedata.levels, { levelId: levelIds[0] });
          if (
            _.some(vm.filters, function(filter) {
              return filter.level.hierarchyId === level.hierarchyId;
            }) &&
            newVal.length > oldVal.length
          ) {
            vm.PromptWarning(
              "Filter not allowed",
              `Filtering dimensions that belongs to the same hierarchy is not allowed.`
            );
            vm.$emit("update:filters", _.cloneDeep(vm.filters));
            return;
          } else {
            this.$emit("add-remove-filter", level);
          }
        }
      },
      get: function() {
        var vm = this;
        if (vm.filters.length) {
          return _.flatMap(vm.filters, function(v) {
            return v.level.levelId;
          });
        } else {
          return [];
        }
      }
    }
  },
  watch: {
    selectedMeasureGroups(newVal) {
      var vm = this;
      var relatedMeasures = _.filter(vm.cubedata.measures, function(measure) {
        return _.includes(newVal, measure.measureGroupId);
      });
      var measures = _.chain(relatedMeasures)
        .groupBy("measureGroupId")
        .map(function(measures, measureGroupId) {
          return {
            id: measureGroupId,
            label: _.find(vm.cubedata.measureGroups, {
              measureGroupId: measureGroupId
            }).measureGroupCaption,
            children: _.map(measures, function(measure) {
              return {
                id: measure.measureId,
                label: measure.measureCaption
              };
            })
          };
        })
        .orderBy(["measureGroupId"])
        .value();

      vm.relatedMeasures = measures;

      var relatedDimensions = _.filter(
        vm.cubedata.measureGroupDimension,
        function(measureGroupDimension) {
          return _.includes(newVal, measureGroupDimension.measureGroupId);
        }
      );

      //All selected facts has these dimensions
      var commonDimensions = _.chain(relatedDimensions)
        .groupBy("dimensionId")
        .map(function(arr, dimensionId) {
          return { dimensionId: dimensionId, length: arr.length };
        })
        .filter(function(dimension) {
          return dimension.length === newVal.length;
        })
        .value();

      var commonLevels = _.filter(vm.cubedata.levels, function(level) {
        return _.some(commonDimensions, {
          dimensionId: level.dimensionId
        });
      });

      var levels = _.chain(commonLevels)
        .groupBy("dimensionId")
        .map(function(levels, dimensionId) {
          var children = _.chain(levels)
            .groupBy("hierarchyId")
            .map(function(arr, hierarchyId) {
              if (arr.length === 1) {
                return {
                  id: arr[0].levelId,
                  label: arr[0].levelCaption
                };
              } else {
                var split = hierarchyId.split("].[");
                var name = split[split.length - 1];
                name = name.substring(0, name.length - 1);
                return {
                  id: hierarchyId,
                  label: name,
                  children: _.map(arr, function(level) {
                    var spaces = "﹥".repeat(parseInt(level.levelNumber) - 1);
                    return {
                      id: level.levelId,
                      label: spaces + level.levelCaption
                    };
                  })
                };
              }
            })
            .value();
          return {
            id: dimensionId,
            label: dimensionId.substring(1, dimensionId.length - 1),
            children: children
          };
        })
        .value();

      vm.relatedLevels = levels;

      var relatedLevels = _.filter(vm.cubedata.levels, function(level) {
        return _.some(relatedDimensions, {
          dimensionId: level.dimensionId
        });
      });

      var filters = _.chain(relatedLevels)
        .filter("isFilterable")
        .groupBy("dimensionId")
        .map(function(levels, dimensionId) {
          var children = _.chain(levels)
            .groupBy("hierarchyId")
            .map(function(arr, hierarchyId) {
              if (arr.length === 1) {
                return {
                  id: arr[0].levelId,
                  label: arr[0].levelCaption
                };
              } else {
                var split = hierarchyId.split("].[");
                var name = split[split.length - 1];
                name = name.substring(0, name.length - 1);
                return {
                  id: arr[0].levelId,
                  label: name + " (" + arr.length + ")"
                  // children: _.map(arr, function(level) {
                  //   var spaces = '﹥'.repeat(parseInt(level.levelNumber) - 1);
                  //   return {
                  //     id: level.levelId,
                  //     label: spaces + level.levelCaption
                  //   };
                  // })
                };
              }
            })
            .value();
          return {
            id: dimensionId,
            label: dimensionId.substring(1, dimensionId.length - 1),
            children: children
          };
        })
        //.orderBy(['dimensionId', 'hierarchyId'], ['asc', 'asc'])
        .value();

      this.relatedFilters = filters;

      //Add Date to filter if relatedFilters exist
      // var dimHourDateExist = false;
      // _.forEach(filters, function(filter) {
      //   _.forEach(filter.children, function(filterChild) {
      //     if (filterChild.id === '[Dim Hour].[Date].[Date]') {
      //       dimHourDateExist = true;
      //       return false;
      //     }
      //   });
      //   if (dimHourDateExist === true) return false;
      // });
      // if (dimHourDateExist) {
      //   vm.$emit(
      //     'add-filter',
      //     _.find(vm.cubedata.levels, { levelId: '[Dim Hour].[Date].[Date]' })
      //   );
      // }

      this.RemoveUnrelated();
    }
  },
  methods: {
    NormalizerFacts(node) {
      return {
        id: node.measureGroupId,
        label: node.measureGroupCaption
      };
    },
    UpdateLevels() {
      var vm = this;
      var levels = _.filter(vm.cubedata.levels, function(level) {
        return _.includes(vm.selectedLevels, level.levelId);
      });
      this.$emit("update:levels", levels);
    },
    RemoveUnrelated() {
      var vm = this;
      //Remove SelectedLevels
      var relatedLevelIds = _.chain(vm.relatedLevels)
        .flatMap(function(v) {
          return v.children;
        })
        .flatMap(function(v) {
          return { levelId: v.id };
        })
        .value();
      vm.selectedLevels = _.filter(vm.selectedLevels, function(levelId) {
        return _.some(relatedLevelIds, { levelId: levelId });
      });
      //Remove SelectedMeasures
      var relatedMeasureIds = _.chain(vm.relatedMeasures)
        .flatMap(function(v) {
          return v.children;
        })
        .flatMap(function(v) {
          return { measureId: v.id };
        })
        .value();
      vm.selectedMeasures = _.filter(vm.selectedMeasures, function(measureId) {
        return _.some(relatedMeasureIds, { measureId: measureId });
      });
      //Remove SelectedFilters
      var relatedFilterIds = _.chain(vm.relatedFilters)
        .flatMap(function(v) {
          return v.children;
        })
        .flatMap(function(v) {
          return { levelId: v.id };
        })
        .value();
      var filtersToBeRemoved = _.filter(vm.selectedFilters, function(levelId) {
        return !_.some(relatedFilterIds, { levelId: levelId });
      });
      _.forEach(filtersToBeRemoved, function(v) {
        var level = _.find(vm.cubedata.levels, { levelId: v });
        vm.$emit("add-remove-filter", level);
      });
    },
    measureGroupChangedBySelect() {
      setTimeout(() => {
        //Add Date to filter if relatedFilters exist
        let dimHourDateExist = false;
        const filters = _.cloneDeep(this.relatedFilters);
        _.forEach(filters, function(filter) {
          _.forEach(filter.children, function(filterChild) {
            if (filterChild.id === "[Dim Hour].[Date].[Date]") {
              dimHourDateExist = true;
              return false;
            }
          });
          if (dimHourDateExist === true) return false;
        });
        if (dimHourDateExist) {
          this.$emit(
              "add-filter",
              _.find(this.cubedata.levels, { levelId: "[Dim Hour].[Date].[Date]" })
          );
        }
      }, 500)
    }
  }
};
</script>